import { Action } from "redux";

import { GET_USERS, GET_USER_BY_ID, SET_USER_TO_NULL } from "./types";

type UserAction = {
  type: "GET_USERS" | "GET_USER_BY_ID" | "SET_USER_TO_NULL";
  payload: any;
};

const initialState = {
  users: [],
  currentUser: null,
};

export default (state = initialState, action: UserAction) => {
  switch (action.type) {
    case GET_USERS:
      return {
        ...state,
        users: action.payload,
      };
    case GET_USER_BY_ID:
      return {
        ...state,
        currentUser: action.payload,
      };
    case SET_USER_TO_NULL:
      return {
        ...state,
        currentUser: null,
      };
    default:
      return state;
  }
};
